import image1 from "../../assets/img/Productos/Indumentaria.jpg";
import image2 from "../../assets/img/Productos/Impacto.jpg";
import image3 from "../../assets/img/Productos/Pañuelos_Isolina.jpg";
import image4 from "../../assets/img/Productos/Accesorios_Isadora.jpg";

export const cards = [
  {
    id: 0,
    background: image1,
    title: "Indumentaria",
    text: "Generamos estampas lúdicas para crear prendas atemporales que se adapten a todos los cuerpos. Creemos que la ropa es mucho más que solo vestirse, por eso, buscamos que quienes usen nuestras prendas puedan sentir comodidad, comunicarse y expresarse.",
  },
  {
    id: 1,
    background: image2,
    title: "Impacto",
    text: "Reducimos nuestros excedentes a través de un proceso productivo amigable con el ambiente y con las personas. Transformamos descartes textiles propios y de otras empresas -como Thor 4x4- en accesorios.",
  },
  {
    id: 2,
    background: image3,
    title: "Pañuelos Isolina",
    text: "La versatilidad de los pañuelos es la esencia de esta cápsula. Son accesorios que se adaptan a todas las estaciones del año y a múltiples situaciones de uso.",
  },
  {
    id: 3,
    background: image4,
    title: "Accesorios Isidora",
    text: "Accesorios con impacto que nacen de la idea de darle nuevo valor a los descartes textiles.",
  },
];
